import * as t from "io-ts";
import { decode } from "io-ts-promise";
import { rentalBillingPreviewT, rentalBillingClientsT } from "dora-contracts";

export type { RentalBillingPreview } from "dora-contracts";
// dora-contracts exports the codec but not a matching type for the client
// list, so derive it here rather than re-declaring `string[]` at the call
// site.
export type RentalBillingClients = t.TypeOf<typeof rentalBillingClientsT>;
export const decodeRentalBillingPreview = decode(rentalBillingPreviewT);
export const decodeRentalBillingClients = decode(rentalBillingClientsT);
